import React  from 'react';
import ReactDom  from 'react-dom';
import './index.css';
// import { App } from '../src/Components/App';
import App from '../src/Components/App';
import I18wrapper from "./I18wrapper";
import 'bootstrap/dist/css/bootstrap.css';
import "./i18n";

ReactDom.render(
    <React.Suspense fallback={''}>
        <App />
    </React.Suspense>
    ,document.getElementById('root'));



